<script setup lang="ts"></script>
<template>
  <div
    class="after:content-[' '] mx-auto flex size-20 after:block after:size-16 after:animate-spin after:rounded-[50%] after:border-[6px] after:border-solid after:border-x-transparent after:border-y-primary"
  ></div>
</template>
